import _ from "lodash";
import React from "react";
import CustomSelect from "../../common/CustomSelect";
import { DuplicateLead, Lead } from './LeadDataGridStore';
import { SelectOption } from 'src/types/common';
import { client } from 'src/utils/axios-client';
import { Box, Button, Chip, LinearProgress, Typography } from '@mui/material';
import Popover from '@mui/material/Popover';
import { leadDataManagementEndpoint } from "../../../configs/endpoints";
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import SimpleDialog from "../../common/SimpleDialog";
import DuplicateLeadTable from "./DuplicateLeadTable";
import ExcelImportStore from "./ExcelImportStore";

type Props = {
    lead: Lead,
}

const StatusColumn = ({ lead }: Props) => {
    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState(false);
    const [duplicateLeads, setDuplicateLeads] = React.useState([] as DuplicateLead[]);
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const customerId = ExcelImportStore.useState(s => s.session.customerId);

    React.useEffect(() => {
        checkForDuplicates();
    }, [lead])

    const checkForDuplicates = async () => {
        const response = await client.post<DuplicateLead[]>(leadDataManagementEndpoint + '/duplicates', { ...lead, customerId: customerId })

        if (response.data.length === 0) {
            setSuccess(true)
            setDuplicateLeads([]);
        } else {
            setDuplicateLeads(response.data);
        }

        setLoading(false);
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setDialogOpen(true);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    {loading && <LinearProgress color='success' />}
                    {!loading && success && <Chip icon={<DoneIcon />} label="No" color='success' size='small' />}
                    {!loading && !success && <Chip onClick={handleClick} icon={<ErrorIcon />} label={`Yes (${duplicateLeads.length})`} color='error' size='small' />}
                    {!loading && !success && duplicateLeads.length > 0 && <SimpleDialog open={dialogOpen} onClose={() => setDialogOpen(false)} size={'md'} fullHeight={false}>
                        <Box>
                            <Typography variant='h6'>Possible Duplicate Leads</Typography>
                        </Box>
                        <DuplicateLeadTable leads={duplicateLeads} />

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button variant="contained" size="small" onClick={()=> setDialogOpen(false) }>Close</Button>
                        </Box>
                    </SimpleDialog>}
                </Box>
            </Box>
        </Box>
    )
}

export { StatusColumn }
export default StatusColumn;